/*
 * @Author: Teemo Ding
 * @Date: 2021-12-02 14:55:48
 * @LastEditTime: 2022-04-29 16:00:27
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Order/Components/Products/index.tsx
 */
import React from 'react';
import { get } from 'lodash';
import { Form } from 'antd';
import ProductsItems from '../ProductsItems';
import { SectionWrapper } from 'src/components/Layouts';
import css from './css.module.less';
import { EnumFilterType } from 'src/constrains/Query1/Filter';
import {
  EnumLinkProductType1,
  //typeDict,
} from 'src/types/common/salesChannelProduct';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';

const iniProps = { inStock: true, visible: true };
const customerConvertQuery = (filter) => {
  const re: any = { ...iniProps };
  if (filter.productTypes) {
    if (filter.productTypes.length > 0) {
      re.productTypes = [filter.productTypes[0].value];
    }
  }
  if (filter.tags) {
    if (filter.tags.length > 0) {
      re.tags = filter.tags.map((i) => {
        const { value } = i;
        return { uuid: value };
      });
    }
  }
  // if (filter.visible) {
  //   if (filter.visible.length > 0) {
  //     re.visible = filter.visible[0].value == 'visible-1' ? true : false;
  //   }
  // }

  //if (customFilterTransfer) customFilterTransfer(filter, re);
  return re;
};
const Products = ({ disable, currency, keyUuid }) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const filterList = ({ tags }) => [
    {
      type: EnumFilterType.SingleSelection,
      dropdownProps: { name: getI18n('general.type') },
      keyWord: 'productTypes',
      options: [
        {
          label: getI18n('general.status.singlePhy'),
          value: EnumLinkProductType1.SinglePhysical,
        },
        {
          label: getI18n('general.status.singleSer'),
          value: EnumLinkProductType1.SingleService,
        },
        {
          label: getI18n('general.status.singleGC'),
          value: EnumLinkProductType1.SingleGiftCard,
        },
        {
          label: getI18n('general.status.multiplePhy'),
          value: EnumLinkProductType1.MultiplePhysical,
        },
        {
          label: getI18n('general.status.multipleVir'),
          value: EnumLinkProductType1.MultipleVirtual,
        },
      ],
    },
    {
      type: EnumFilterType.MultipleSelection,
      dropdownProps: { name: getI18n('general.tags') },
      keyWord: 'tags',
      options: tags.map((item) => ({
        label: item.name,
        value: item.uuid,
      })),
      searchable: true,
    },
  ];

  const initialSearchProps = React.useMemo(
    () => ({ ...iniProps, currencyCode: currency }),
    [currency],
  );

  return (
    <SectionWrapper
      title={getI18n('allOrders.createneworder.components_products_tite')}
      subtitle={getI18n(
        'allOrders.createneworder.components_products_subtitle',
      )}
      containerClassName={css.section}
      titleClassName={css.sectionTitle}>
      <Form.Item
        noStyle
        shouldUpdate={(p, c) => {
          const cC = get(c, 'salesChannel.uuid');
          const pC = get(p, 'salesChannel.uuid');
          return cC !== pC;
        }}>
        {({ getFieldValue }: any) => (
          <Form.Item name='products' initialValue={[]} noStyle>
            <ProductsItems
              initialSearchProps={initialSearchProps}
              showDelete
              addText={getI18n(
                'allOrders.createneworder.components_products_AddProduct',
              )}
              keyUuid={keyUuid}
              disabled={disable}
              currency={currency}
              filterList={filterList}
              customerConvertQuery={customerConvertQuery}
              salesChannelUuid={(getFieldValue('salesChannel') || {}).uuid}
            />
          </Form.Item>
        )}
      </Form.Item>
    </SectionWrapper>
  );
};

export default Products;
